import { Alert, Platform } from 'react-native'

const AlertWrapper =
  Platform.OS === 'web' ? require('$utils/Alert.web.js').default : Alert

export default AlertWrapper
